/* eslint no-param-reassign: "off" */
import posthog from 'posthog-js';
import getEnvironmentConfig from '../get-environment-config';

const envConfig = getEnvironmentConfig();

// This is a write-only project token so it's safe to expose it here
const POSTHOG_PROJECT_API_KEYS = {
  production: 'phc_4jh3foxiA4DlDLpfG7ffveeitUxQHhB13SYLTovWioS',
  staging: 'phc_yPDKDpJ7mi35H72wf6oYRn8noCdA5mexrhx7VCAjAEtD',
  dev: 'phc_mvxxUjRxGFVZiJnBpc3VthLRiUEocscDgwMAPE4jBFJT',
};

export default {
  install(app) {
    if (envConfig.environment === 'local') {
      return;
    }
    const posthogKey = POSTHOG_PROJECT_API_KEYS[envConfig.environment];
    const client = posthog.init(posthogKey, {
      api_host: 'https://eu.i.posthog.com',
      persistence: 'memory',
      capture_pageview: 'history_change',
      capture_pageleave: true,
      capture_dead_clicks: false,
      autocapture: {
        dom_event_allowlist: ['click'],
        element_allowlist: ['button', 'a', 'input', 'select', 'label', 'form'],
      },
    });
    app.config.globalProperties.$posthog = client;
    // Certain posthog features expect a global posthog instance, hence adding to window here
    window.posthog = client;
  },
};
